import{ Company } from '../../models/company/company.model';

export class CompanyByCifResponse {
    companies: Company[];

    constructor(companies: Company[]) {
        this.companies = companies;
    }
}
